/* W79 — WHERE A `⋯` MENU DRAWS ONCE IT LIVES IN THE TOP LAYER.
 *
 * His report, 2026-09-25 ~19:00 (Safari, coachwork.io): *"why i tapped the 3 dots and looks like this??"* — the day
 * cell's menu read "…iew" / "…ide from client". MEASURED on the stub at 1440: the square closed cell is
 * `overflow: hidden` and the menu was drawn INSIDE it, right-aligned to the `⋯`, so it ran 21 px past the cell's left
 * edge and 50–114 px past its bottom; `elementFromPoint` at every item's left edge hit something else.
 *
 * The menu now renders in the TOP LAYER (a popover), which no ancestor's `overflow`, containment or transform can clip —
 * and a box in the top layer has no parent to be positioned by, so its position is this function's answer, in
 * viewport pixels (`position: fixed`). Pure, so the rule is tested without a browser.
 *
 * The rule, as a sentence: the menu opens just under the `⋯`, its left edge on the `⋯`'s left edge (the `⋯` sits at the
 * start of a cell's line, so the menu opens across its own cell, never over the nav rail); if that would run off the right
 * it lines its right edge up with the `⋯`'s instead; if it would run off the bottom it opens ABOVE the `⋯`; and
 * whatever happens it stays `margin` px inside the viewport on every side (a menu taller than the viewport pins to the
 * top — its own list scrolls, never the page).
 */
export type Box = { left: number; top: number; right: number; bottom: number };

export function menuPlacement(
  trigger: Box,
  menu: { width: number; height: number },
  viewport: { width: number; height: number },
  gap = 4,
  margin = 8,
): { left: number; top: number; above: boolean } {
  const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(v, hi));
  const fitsRight = trigger.left + menu.width <= viewport.width - margin;
  const left = clamp(fitsRight ? trigger.left : trigger.right - menu.width, margin, viewport.width - margin - menu.width);
  const below = trigger.bottom + gap;
  const fitsBelow = below + menu.height <= viewport.height - margin;
  const aboveTop = trigger.top - gap - menu.height;
  const above = !fitsBelow && aboveTop >= margin;
  const top = above ? aboveTop : clamp(below, margin, viewport.height - margin - menu.height);
  return { left: Math.max(margin, left), top: Math.max(margin, top), above };
}
